import { $WC, $DKD, $GCD } from '@/conf/common.const.js';
import gripUtil from "@/lib/grip.util.js";
import commonApi from "@/api/common.api.js";

export default {
    state: {
        // 행정동 정보 목록
        hjdInfoList: [],
        // 시설 분류 코드 목록
        facCategoryCodeList: [],
        // 시설 자료 종류 목록
        facRepoList: [],
        // 시설 자료 종류 맵
        facRepoMap: {},
        // 시설 컬럼 정보 맵
        facColMap: {},
        // 시설 데이터 맵
        facDataMap: {dataLoaded: false},
        //현장방문 년도
        visitYearList: [],
        //현장방문 년도 선택
        selectedYearMonthCd: '',
        // 시설 자료 정보 맵
        facDatakdMap: {},

    },
    getters: {
        getHjdInfoList(state) {
            return state.hjdInfoList;
        },
        getFacCategoryCodeList(state) {
            return state.facCategoryCodeList;
        },
        getFacRepoList(state) {
            return state.facRepoList;
        },
        getFacRepoMap(state) {
            return state.facRepoMap;
        },
        getFacColMap(state) {
            return state.facColMap;
        },
        getFacDataMap(state) {
            return state.facDataMap;
        },
        getFacDatakdMap(state) {
            return state.facDatakdMap;
        },
        getVisitYearList(state) {
            return state.visitYearList;
        },
        getSelectedYearMonthCd(state) {
            return state.selectedYearMonthCd;
        },
    },
    mutations: {
        HJD_INFO_LIST(state, hjdInfoList) {
            state.hjdInfoList = hjdInfoList;
        },
        FAC_CATEGORY_CODE_LIST(state, facCategoryCodeList) {
            state.facCategoryCodeList = facCategoryCodeList;
        },
        FAC_REPO_LIST(state, facRepoList) {
            state.facRepoList = facRepoList;
        },
        FAC_REPO_MAP(state, facRepoMap) {
            state.facRepoMap = facRepoMap;
        },
        FAC_COL_MAP(state, facColMap) {
            state.facColMap = facColMap;
        },
        FAC_DATA_MAP(state, facDataMap) {
            facDataMap.dataLoaded = true;
            state.facDataMap = facDataMap;
        },
        FAC_DATAKD_MAP(state, facDatakdMap){
            state.facDatakdMap = facDatakdMap;
        },
        VISIT_YEAR_LIST(state, visitYearList) {
            state.visitYearList = visitYearList;
        },
        SELECTED_YEAR_MONTH_CD(state, selectedYearMonthCd) {
            state.selectedYearMonthCd = selectedYearMonthCd;
        },
    },
    actions: {
        FETCH_HJD_INFO_LIST({commit}) {
            return commonApi.fetchRepoDataList($DKD.HJD_INFO)
                .then(res => {
                    commit('HJD_INFO_LIST', res.data.data);
                });
        },
        FETCH_FAC_CATEGORY_CODE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($GCD.FACILITY_CAT)
                .then(res => {
                    let list = res.data.data.filter(function(data){
                        if(window.location.href.indexOf('lifemap') > -1){
                            return data.commonCode != '10';
                        }else{
                            return data.commonCode == '10';    
                        }
                    })
                    commit('FAC_CATEGORY_CODE_LIST', list);
                });
        },
        FETCH_FAC_REPO_LIST({commit}) {
            return commonApi.fetchRepoListByCodeGroup($GCD.FACILITY_CAT)
                .then(res => {
                    let facRepoList = res.data.data;
                    commit('FAC_REPO_LIST', facRepoList);
                    commit('FAC_REPO_MAP', gripUtil.toMap(facRepoList, 'sclasCd'));
                });
        },
        FETCH_FAC_DATA({commit}, dataKdSqnos) {
            return commonApi.fetchIncludeMetaDataBySqnos(dataKdSqnos, 1)
                .then(res => {
                    let facData = res.data.data;
                    //현장방문 년도 리스트
                    let list = [];
                    for(let key in facData.dataKdMap){
                        if(facData.dataKdMap[key].sclasCd === "10"){
                            facData.dataMap[key].forEach(function(data){
                                let date = data.basdtVal.substr(0,4);
                                list.push(date);
                            })
                        }
                    }
                    commit('VISIT_YEAR_LIST', Array.from(new Set(list)));
                    commit('FAC_DATAKD_MAP', facData.dataKdMap);
                    commit('FAC_COL_MAP', facData.dataKdHdngMap);
                    commit('FAC_DATA_MAP', facData.dataMap);
                });
        },
        SET_SELECTED_YEAR_MONTH_CD({commit}, selectedYearMonthCd){
            commit('SELECTED_YEAR_MONTH_CD', selectedYearMonthCd);
        },
    }
}
